export const deleteUser = async (accessToken: string): Promise<boolean> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/account`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to delete account.");
    }

    console.log("Your account has been successfully deleted.");
    return true;
  } catch (error) {
    console.error("Error deleting user account:", error);
    return false;
  }
};
